.root {
  display: inline-flex;
  height: 18px;
  align-items: center;
  padding: 0 8px;
  border: 1px solid var(--x-color-text-primary-disabled);
  border-radius: 4px;
  background-color: var(--x-color-text-primary-disabled);
  color: white;
  font-size: 13px;
  white-space: nowrap;

  &.round {
    border-radius: 16px;
  }

  &.square {
    border-radius: 2px;
  }

  &.medium {
    height: 22px;
  }

  &.large {
    height: 24px;
    font-size: 14px;
    font-weight: 600;
  }

  &.outline {
    border-color: var(--x-color-border);
    background-color: var(--x-color-background);
    color: var(--x-color-text-primary);
  }

  &.red {
    border-color: var(--x-color-text-red);
    background-color: var(--x-color-text-red);

    &.outline {
      border-color: var(--x-color-background-red-darker);
      background-color: var(--x-color-background-red);
      color: var(--x-color-text-red);
    }
  }

  &.brown {
    border-color: #865748;
    background-color: #865748;

    &.outline {
      border-color: #e9e2e1;
      background-color: #f5f2f1;
      color: #865748;
    }
  }

  &.orange {
    border-color: var(--x-color-text-orange);
    background-color: var(--x-color-text-orange);

    &.outline {
      border-color: var(--x-color-background-orange-darker);
      background-color: var(--x-color-background-orange);
      color: var(--x-color-text-orange);
    }
  }

  &.yellow {
    border-color: #d4b106;
    background-color: #d4b106;

    &.outline {
      border-color: #fffb8f;
      background-color: #fffee8;
      color: #d48806;
    }
  }

  &.beige {
    border-color: #b9a287;
    background-color: #b9a287;

    &.outline {
      background-color: #f6f3ef;
      color: #a78a68;
    }
  }

  &.green {
    border-color: var(--x-color-text-green);
    background-color: var(--x-color-text-green);

    &.outline {
      border-color: var(--x-color-background-green-darker);
      background-color: var(--x-color-background-green);
      color: var(--x-color-text-green);
    }
  }

  &.purple {
    border-color: #4d5bd8;
    background-color: #4d5bd8;

    &.outline {
      border-color: #dce8ff;
      background-color: #eff0ff;
      color: #4d5bd8;
    }
  }

  &.blue {
    border-color: var(--x-color-text-accent);
    background-color: var(--x-color-text-accent);

    &.outline {
      border-color: var(--x-color-background-accent-darker);
      background-color: var(--x-color-background-accent);
      color: #45505a;
    }
  }

  &.white.outline {
    background-color: white;
  }

  &.uppercase {
    letter-spacing: 0.65px;
    text-transform: uppercase;
  }
}

.tooltip {
  white-space: pre-line;
}
